// "use client";

// import { useState, useEffect, useRef } from "react";
// import { useForm } from "react-hook-form";
// import { z } from "zod";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { toast } from "sonner";
// import {
//   Phone,
//   Mail,
//   MapPin,
//   Send,
//   Clock,
//   Sparkles,
//   HelpCircle,
//   ExternalLink,
//   ShieldCheck,
//   CheckCircle2,
// } from "lucide-react";

// import ReCAPTCHA from "react-google-recaptcha";

// import InputField from "@/components/common/InputField";
// import SelectField from "@/components/common/SelectBox";
// import Modal from "@/components/common/Modal";
// import { Button } from "@/components/ui/button";
// import { contactThroughMessage } from "@/api-service/contact";
// import { useGeneralSettings } from "@/packages/context/GeneralSettingContext";
// import { useFastRouter } from "@/packages/hooks/useFastRouter";
// import { HEADER_V2_DESIGN_SYSTEM } from "@/components/header/v2/designTokens";

// const SUBJECT_OPTIONS = [
//   { label: "General Issues", value: "General Issues" },
//   { label: "Product Related Issues", value: "Product Related Issues" },
//   { label: "Order Related Issues", value: "Order Related Issues" },
//   { label: "Payment Issues", value: "Payment Issues" },
//   { label: "Shipping & Delivery Issues", value: "Shipping & Delivery Issues" },
//   // { label: "Returns & Refunds", value: "Returns & Refunds" },
//   { label: "Other Inquiries", value: "Other Inquiries" },
// ];

// // ---------------- Validation Schema ----------------
// const contactSchema = z.object({
//   name: z.string().min(1, "Full name is required").refine((val) => val.trim().length > 0, "Full name cannot be blank spaces"),
//   email: z.string().min(1, "Email address is required").email("Please enter a valid email address"),
//   phone: z.string().optional(),
//   subject: z.string().min(1, "Subject is required"),
//   message: z
//     .string()
//     .min(1, "Message is required")
//     .refine((val) => val.trim().length >= 10, {
//       message: "Message must be at least 10 characters long (excluding whitespace)",
//     }),
// });

// type ContactFormData = z.infer<typeof contactSchema>;

// interface ContactInfo {
//   phone: string;
//   secondary_phone?: string;
//   email: string;
//   secondary_email?: string;
//   address: string;
//   city: string;
//   state: string;
//   country: string;
//   zip_code: number | string;
// }

// export default function ContactForm() {
//   const { fastPush } = useFastRouter();
//   const recaptchaRef = useRef<ReCAPTCHA | null>(null);
//   const [captchaToken, setCaptchaToken] = useState<string>("");
//   const [loading, setLoading] = useState(false);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [contactInfo, setContactInfo] = useState<ContactInfo | null>(null);
//   const { settings } = useGeneralSettings();

//   const {
//     register,
//     handleSubmit,
//     reset,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm<ContactFormData>({
//     resolver: zodResolver(contactSchema),
//   });

//   useEffect(() => {
//     if (settings && settings.contact) {
//       setContactInfo(settings.contact);
//     }
//   }, [settings]);

//   const handleCaptchaChange = (token: string | null) => {
//     setCaptchaToken(token || "");
//   };

//   const onSubmit = async (data: ContactFormData) => {
//     if (!captchaToken) {
//       toast.error("Please verify that you are not a robot");
//       return;
//     }

//     try {
//       setLoading(true);
//       await contactThroughMessage({
//         ...data,
//         captchaToken,
//       });

//       setShowSuccessModal(true);
//       reset({
//         name: "",
//         email: "",
//         phone: "",
//         subject: "",
//         message: "",
//       });
//       setCaptchaToken("");
//       recaptchaRef.current?.reset();
//     } catch (error: unknown) {

//       const errorRecord = (error as Record<string, unknown>)?.response as
//         | Record<string, unknown>
//         | undefined;
//       const errorData = errorRecord?.data as
//         | Record<string, unknown>
//         | undefined;
//       const message =
//         (errorData?.message as string) || "Failed to send your message. Please try again.";
//       toast.error(message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fullAddress = contactInfo?.address
//     ? `${contactInfo.address}, ${contactInfo.city}, ${contactInfo.state}, ${contactInfo.country} ${contactInfo.zip_code}`
//     : "";

//   return (
//     <main className="min-h-screen bg-slate-50/50 pb-20 pt-6 font-sans">
//       {/* Hero Header */}
//       <section className="relative overflow-hidden bg-[var(--brand-text-dark)] text-white py-12 md:py-16 px-4 mb-10 shadow-lg border-b border-white/10">
//         <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[var(--brand-accent)]/20 via-transparent to-transparent opacity-50 pointer-events-none" />
//         <div className="max-w-4xl mx-auto text-center relative z-10">
//           <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-amber-300 text-xs font-semibold uppercase tracking-wider mb-4">
//             <Sparkles className="w-4 h-4 text-[var(--brand-accent)]" />
//             <span>24/7 Global Customer Care</span>
//           </div>
//           <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight text-white mb-4">
//             Get in Touch with Us
//           </h1>
//           <p className="text-slate-300 text-sm md:text-base max-w-2xl mx-auto font-normal leading-relaxed">
//             Have a question about an order, shipping, or product details? We&apos;re here to help you every step of the way.
//           </p>
//         </div>
//       </section>

//       <div className={`max-w-7xl mx-auto ${HEADER_V2_DESIGN_SYSTEM.spacing.containerPadding} space-y-12`}>
//         {/* Quick Contact Cards */}
//         <section className="grid grid-cols-1 md:grid-cols-3 gap-6">
//           {/* Phone Card */}
//           <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs hover:shadow-md transition-all group">
//             <div className="w-12 h-12 rounded-xl bg-amber-50 text-[var(--brand-accent)] flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
//               <Phone className="w-6 h-6" />
//             </div>
//             <h3 className="text-base font-bold text-slate-900 mb-1">Phone Support</h3>
//             <p className="text-xs text-slate-500 mb-3">Speak directly with our support team.</p>
//             {contactInfo?.phone ? (
//               <a
//                 href={`tel:${contactInfo.phone}`}
//                 className="text-sm font-bold text-[var(--brand-accent)] hover:underline flex items-center gap-1.5"
//               >
//                 <span>{contactInfo.phone}</span>
//               </a>
//             ) : (
//               <span className="text-xs text-slate-400">Loading phone number...</span>
//             )}
//             <div className="mt-4 pt-3 border-t border-slate-100 text-[11px] text-slate-400 flex items-center gap-1">
//               <Clock className="w-3.5 h-3.5 text-slate-400" />
//               <span>Mon – Sat: 9:00 AM – 6:00 PM EST</span>
//             </div>
//           </div>

//           {/* Email Card */}
//           <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs hover:shadow-md transition-all group">
//             <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
//               <Mail className="w-6 h-6" />
//             </div>
//             <h3 className="text-base font-bold text-slate-900 mb-1">Email Assistance</h3>
//             <p className="text-xs text-slate-500 mb-3">Send us an email anytime.</p>
//             {contactInfo?.email ? (
//               <a
//                 href={`mailto:${contactInfo.email}`}
//                 className="text-sm font-bold text-emerald-600 hover:underline flex items-center gap-1.5"
//               >
//                 <span>{contactInfo.email}</span>
//               </a>
//             ) : (
//               <span className="text-xs text-slate-400">Loading support email...</span>
//             )}
//             <div className="mt-4 pt-3 border-t border-slate-100 text-[11px] text-slate-400 flex items-center gap-1">
//               <ShieldCheck className="w-3.5 h-3.5 text-emerald-500" />
//               <span>Average response time &lt; 24 Hours</span>
//             </div>
//           </div>

//           {/* Location Card */}
//           <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs hover:shadow-md transition-all group">
//             <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
//               <MapPin className="w-6 h-6" />
//             </div>
//             <h3 className="text-base font-bold text-slate-900 mb-1">Global Headquarters</h3>
//             <p className="text-xs text-slate-500 mb-3">Visit or send mail to our primary address.</p>
//             {fullAddress ? (
//               <p className="text-xs font-semibold text-slate-700 leading-relaxed mb-2">
//                 {fullAddress}
//               </p>
//             ) : (
//               <span className="text-xs text-slate-400">Loading headquarters address...</span>
//             )}
//             {fullAddress && (
//               <a
//                 href={`https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}`}
//                 target="_blank"
//                 rel="noreferrer"
//                 className="inline-flex items-center gap-1 text-[11px] font-bold text-blue-600 hover:underline mt-1"
//               >
//                 <span>Get Directions</span>
//                 <ExternalLink className="w-3 h-3" />
//               </a>
//             )}
//           </div>
//         </section>

//         {/* Main Form & Information Section */}
//         <section className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
//           {/* Form Container */}
//           <div className="lg:col-span-7 bg-white rounded-2xl border border-slate-200/90 p-6 md:p-8 shadow-xs">
//             <h2 className="text-2xl font-bold text-slate-900 mb-2">Send Us a Message</h2>
//             <p className="text-xs md:text-sm text-slate-500 mb-6">
//               Fill out the form below. A dedicated support specialist will review and respond shortly.
//             </p>

//             <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
//               {/* Name & Email Row */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

//                 <InputField
//                   label="Full Name *"
//                   placeholder="e.g. John Doe"
//                   {...register("name")}
//                   error={errors.name?.message}
//                   className="bg-slate-50/50"
//                 />
//                 <InputField
//                   label="Email Address *"
//                   type="email"
//                   placeholder="e.g. john@example.com"
//                   {...register("email")}
//                   error={errors.email?.message}
//                   className="bg-slate-50/50"
//                 />
//               </div>

//               {/* Phone & Subject Row */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <InputField
//                   label="Phone Number (Optional)"
//                   type="tel"
//                   placeholder="e.g. +1 555-0199"
//                   {...register("phone")}
//                   error={errors.phone?.message}
//                   className="bg-slate-50/50"
//                 />
//                 <SelectField
//                   name="subject"
//                   label="Subject"
//                   mandatory
//                   placeholder="Select issue type..."
//                   value={watch("subject") || ""}
//                   onChange={(val) => setValue("subject", val, { shouldValidate: true })}
//                   options={SUBJECT_OPTIONS}
//                   error={errors.subject?.message}
//                 />
//               </div>

//               {/* Message */}
//               <div className="space-y-1.5">
//                 <label className="text-xs font-bold uppercase tracking-wider text-slate-500 block">
//                   Your Message *
//                 </label>
//                 <textarea
//                   {...register("message")}
//                   rows={5}
//                   placeholder="Please type your message in detail..."
//                   className={`w-full border rounded-xl p-3.5 text-xs text-slate-900 bg-slate-50/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[var(--brand-accent)] transition-all ${
//                     errors.message ? "border-rose-400" : "border-slate-200"
//                   }`}
//                 />
//                 {errors.message && (
//                   <p className="text-xs text-rose-500 font-medium">{errors.message.message}</p>
//                 )}
//               </div>

//               {/* ReCAPTCHA */}
//               <div className="pt-2">
//                 <ReCAPTCHA
//                   sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "6LccJiosAAAAAGF_7a3p32-tiPQcyeZ0aBWu-PYM"}
//                   onChange={handleCaptchaChange}
//                   ref={recaptchaRef}
//                 />
//               </div>


//               {/* Submit Button */}
//               <Button
//                 type="submit"
//                 disabled={loading}
//                 className="w-full h-12 bg-black hover:bg-slate-800 text-white font-bold text-xs uppercase tracking-wider rounded-xl cursor-pointer shadow-md transition-all flex items-center justify-center gap-2"
//               >
//                 {loading ? (
//                   <>
//                     <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
//                     <span>Sending Message...</span>
//                   </>
//                 ) : (
//                   <>
//                     <span>Send Message</span>
//                     <Send className="w-4 h-4" />
//                   </>
//                 )}
//               </Button>
//             </form>
//           </div>

//           {/* Right Column: FAQ & Help Info */}
//           <div className="lg:col-span-5 space-y-6">
//             <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs space-y-4">
//               <div className="flex items-center gap-2.5 text-slate-900 font-bold text-base border-b border-slate-100 pb-3">
//                 <HelpCircle className="w-5 h-5 text-[var(--brand-accent)]" />
//                 <span>Need Instant Answers?</span>
//               </div>
//               <p className="text-xs text-slate-600 leading-relaxed">
//                 Before reaching out, check our international shipping guidelines and promotional deals for quick solutions:
//               </p>
//               <div className="space-y-2.5 pt-1">
//                 <button
//                   type="button"
//                   onClick={() => fastPush("/shipping-policy")}
//                   className="w-full p-3 rounded-xl border border-slate-200 hover:border-[var(--brand-accent)] bg-slate-50/50 hover:bg-amber-50/40 text-left transition-all flex items-center justify-between group cursor-pointer"
//                 >
//                   <div className="flex items-center gap-2.5">
//                     <CheckCircle2 className="w-4 h-4 text-emerald-600" />
//                     <span className="text-xs font-semibold text-slate-800 group-hover:text-[var(--brand-accent)]">
//                       Shipping & Delivery Timelines
//                     </span>
//                   </div>
//                   <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-[var(--brand-accent)]" />
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => fastPush("/crazy-deals")}
//                   className="w-full p-3 rounded-xl border border-slate-200 hover:border-[var(--brand-accent)] bg-slate-50/50 hover:bg-amber-50/40 text-left transition-all flex items-center justify-between group cursor-pointer"
//                 >
//                   <div className="flex items-center gap-2.5">
//                     <Sparkles className="w-4 h-4 text-amber-500" />
//                     <span className="text-xs font-semibold text-slate-800 group-hover:text-[var(--brand-accent)]">
//                       Deals & Special Offers
//                     </span>
//                   </div>
//                   <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-[var(--brand-accent)]" />
//                 </button>
//               </div>
//             </div>

//             {/* Map Preview Card */}
//             <div className="bg-white rounded-2xl border border-slate-200/90 overflow-hidden shadow-xs">
//               <div className="p-4 bg-slate-50 border-b border-slate-100 flex items-center justify-between">
//                 <span className="text-xs font-bold text-slate-800 flex items-center gap-2">
//                   <MapPin className="w-4 h-4 text-[var(--brand-accent)]" />
//                   <span>Store Location</span>
//                 </span>
//               </div>
//               <div className="h-64 w-full bg-slate-100">
//                 {fullAddress ? (
//                   <iframe
//                     src={`https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`}
//                     width="100%"
//                     height="100%"
//                     allowFullScreen
//                     loading="lazy"
//                     className="border-0 w-full h-full"
//                   ></iframe>
//                 ) : (
//                   <div className="h-full flex items-center justify-center text-xs text-slate-400">
//                     Loading map location...
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>

//       {/* Success Dialog Modal */}
//       <Modal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
//         <div className="p-6 sm:p-8 text-center space-y-4">
//           <div className="w-16 h-16 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto mb-2 shadow-xs">
//             <CheckCircle2 className="w-10 h-10 text-emerald-600" />
//           </div>
//           <h3 className="text-xl font-bold text-slate-900">Message Received!</h3>
//           <p className="text-xs sm:text-sm text-slate-600 max-w-md mx-auto leading-relaxed">
//             Thank you for contacting us. We have successfully received your inquiry and our support team will review your message and solve or get back to you soon.
//           </p>
//           <div className="pt-3">
//             <Button
//               type="button"
//               onClick={() => setShowSuccessModal(false)}
//               className="bg-black hover:bg-slate-800 text-white font-bold px-6 py-2.5 rounded-xl text-xs uppercase tracking-wider shadow-xs cursor-pointer"
//             >
//               Close
//             </Button>
//           </div>
//         </div>
//       </Modal>
//     </main>
//   );
// }







"use client";

import { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import {
  Phone,
  Mail,
  MapPin,
  Send,
  Clock,
  Sparkles,
  HelpCircle,
  ExternalLink,
  ShieldCheck,
  CheckCircle2,
} from "lucide-react";

import ReCAPTCHA from "react-google-recaptcha";

import InputField from "@/components/common/InputField";
import SelectField from "@/components/common/SelectBox";
import Modal from "@/components/common/Modal";
import { Button } from "@/components/ui/button";
import { contactThroughMessage } from "@/api-service/contact";
import { useGeneralSettings } from "@/packages/context/GeneralSettingContext";
import { useFastRouter } from "@/packages/hooks/useFastRouter";
import { HEADER_V2_DESIGN_SYSTEM } from "@/components/header/v2/designTokens";

const SUBJECT_OPTIONS = [
  { label: "General Issues", value: "General Issues" },
  { label: "Product Related Issues", value: "Product Related Issues" },
  { label: "Order Related Issues", value: "Order Related Issues" },
  { label: "Payment Issues", value: "Payment Issues" },
  { label: "Shipping & Delivery Issues", value: "Shipping & Delivery Issues" },
  // { label: "Returns & Refunds", value: "Returns & Refunds" },
  { label: "Other Inquiries", value: "Other Inquiries" },
];

// ---------------- Validation Schema ----------------
const contactSchema = z.object({
  name: z.string().min(1, "Full name is required").refine((val) => val.trim().length > 0, "Full name cannot be blank spaces"),
  email: z.string().min(1, "Email address is required").email("Please enter a valid email address"),
  phone: z.string().optional(),
  subject: z.string().min(1, "Subject is required"),
  message: z
    .string()
    .min(1, "Message is required")
    .refine((val) => val.trim().length >= 10, {
      message: "Message must be at least 10 characters long (excluding whitespace)",
    }),
});

type ContactFormData = z.infer<typeof contactSchema>;

interface ContactInfo {
  phone: string;
  secondary_phone?: string;
  email: string;
  secondary_email?: string;
  address: string;
  city: string;
  state: string;
  country: string;
  zip_code: number | string;
}

export default function ContactForm() {
  const { fastPush } = useFastRouter();
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const [captchaToken, setCaptchaToken] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [contactInfo, setContactInfo] = useState<ContactInfo | null>(null);
  const { settings } = useGeneralSettings();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm<ContactFormData>({
    resolver: zodResolver(contactSchema),
  });

  useEffect(() => {
    if (settings && settings.contact) {
      setContactInfo(settings.contact);
    }
  }, [settings]);

  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token || "");
  };

  const onSubmit = async (data: ContactFormData) => {
    if (!captchaToken) {
      toast.error("Please verify that you are not a robot");
      return;
    }

    try {
      setLoading(true);
      await contactThroughMessage({
        ...data,
        captchaToken,
      });

      setShowSuccessModal(true);
      reset({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
      setCaptchaToken("");
      recaptchaRef.current?.reset();
    } catch (error: unknown) {

      const errorRecord = (error as Record<string, unknown>)?.response as
        | Record<string, unknown>
        | undefined;
      const errorData = errorRecord?.data as
        | Record<string, unknown>
        | undefined;
      const message =
        (errorData?.message as string) || "Failed to send your message. Please try again.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const fullAddress = contactInfo?.address
    ? `${contactInfo.address}, ${contactInfo.city}, ${contactInfo.state}, ${contactInfo.country} ${contactInfo.zip_code}`
    : "";

  return (
    <main className="min-h-screen bg-slate-50/50 pb-20 pt-6 font-sans">
      {/* Hero Header */}
      <section className="relative overflow-hidden bg-[var(--brand-text-dark)] text-white py-12 md:py-16 px-4 mb-10 shadow-lg border-b border-white/10">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[var(--brand-accent)]/20 via-transparent to-transparent opacity-50 pointer-events-none" />
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-amber-300 text-xs font-semibold uppercase tracking-wider mb-4">
            <Sparkles className="w-4 h-4 text-[var(--brand-accent)]" />
            <span>24/7 Global Customer Care</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight text-white mb-4">
            Get in Touch with Us
          </h1>
          <p className="text-slate-300 text-sm md:text-base max-w-2xl mx-auto font-normal leading-relaxed">
            Have a question about an order, shipping, or product details? We&apos;re here to help you every step of the way.
          </p>
        </div>
      </section>

      <div className={`max-w-7xl mx-auto ${HEADER_V2_DESIGN_SYSTEM.spacing.containerPadding} space-y-12`}>
        {/* Quick Contact Cards */}
        <section className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Phone Card */}
          <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs hover:shadow-md transition-all group">
            <div className="w-12 h-12 rounded-xl bg-amber-50 text-[var(--brand-accent)] flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <Phone className="w-6 h-6" />
            </div>
            <h3 className="text-base font-bold text-slate-900 mb-1">Phone Support</h3>
            <p className="text-xs text-slate-500 mb-3">Speak directly with our support team.</p>
            {contactInfo?.phone ? (
              <a
                href={`tel:${contactInfo.phone}`}
                className="text-sm font-bold text-[var(--brand-accent)] hover:underline flex items-center gap-1.5"
              >
                <span>{contactInfo.phone}</span>
              </a>
            ) : (
              <span className="text-xs text-slate-400">Loading phone number...</span>
            )}
            <div className="mt-4 pt-3 border-t border-slate-100 text-[11px] text-slate-400 flex items-center gap-1">
              <Clock className="w-3.5 h-3.5 text-slate-400" />
              <span>Mon – Sat: 9:00 AM – 6:00 PM EST</span>
            </div>
          </div>

          {/* Email Card */}
          <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs hover:shadow-md transition-all group">
            <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <Mail className="w-6 h-6" />
            </div>
            <h3 className="text-base font-bold text-slate-900 mb-1">Email Assistance</h3>
            <p className="text-xs text-slate-500 mb-3">Send us an email anytime.</p>
            {contactInfo?.email ? (
              <a
                href={`mailto:${contactInfo.email}`}
                className="text-sm font-bold text-emerald-600 hover:underline flex items-center gap-1.5"
              >
                <span>{contactInfo.email}</span>
              </a>
            ) : (
              <span className="text-xs text-slate-400">Loading support email...</span>
            )}
            <div className="mt-4 pt-3 border-t border-slate-100 text-[11px] text-slate-400 flex items-center gap-1">
              <ShieldCheck className="w-3.5 h-3.5 text-emerald-500" />
              <span>Average response time &lt; 24 Hours</span>
            </div>
          </div>

          {/* Location Card */}
          <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs hover:shadow-md transition-all group">
            <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <MapPin className="w-6 h-6" />
            </div>
            <h3 className="text-base font-bold text-slate-900 mb-1">Global Headquarters</h3>
            <p className="text-xs text-slate-500 mb-3">Visit or send mail to our primary address.</p>
            {fullAddress ? (
              <p className="text-xs font-semibold text-slate-700 leading-relaxed mb-2">
                {fullAddress}
              </p>
            ) : (
              <span className="text-xs text-slate-400">Loading headquarters address...</span>
            )}
            {fullAddress && (
              <a
                href={`https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 text-[11px] font-bold text-blue-600 hover:underline mt-1"
              >
                <span>Get Directions</span>
                <ExternalLink className="w-3 h-3" />
              </a>
            )}
          </div>
        </section>

        {/* Main Form & Information Section */}
        <section className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* Form Container */}
          <div className="lg:col-span-7 bg-white rounded-2xl border border-slate-200/90 p-6 md:p-8 shadow-xs">
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Send Us a Message</h2>
            <p className="text-xs md:text-sm text-slate-500 mb-6">
              Fill out the form below. A dedicated support specialist will review and respond shortly.
            </p>

            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              {/* Name & Email Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                <InputField
                  label="Full Name *"
                  placeholder="e.g. John Doe"
                  {...register("name")}
                  error={errors.name?.message}
                  className="bg-slate-50/50"
                />
                <InputField
                  label="Email Address *"
                  type="email"
                  placeholder="e.g. john@example.com"
                  {...register("email")}
                  error={errors.email?.message}
                  className="bg-slate-50/50"
                />
              </div>

              {/* Phone & Subject Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <InputField
                  label="Phone Number (Optional)"
                  type="tel"
                  placeholder="e.g. +1 555-0199"
                  {...register("phone")}
                  error={errors.phone?.message}
                  className="bg-slate-50/50"
                />
                <SelectField
                  name="subject"
                  label="Subject"
                  mandatory
                  placeholder="Select issue type..."
                  value={watch("subject") || ""}
                  onChange={(val) => setValue("subject", val, { shouldValidate: true })}
                  options={SUBJECT_OPTIONS}
                  error={errors.subject?.message}
                />
              </div>

              {/* Message */}
              <div className="space-y-1.5">
                <label className="text-xs font-bold uppercase tracking-wider text-slate-500 block">
                  Your Message *
                </label>
                <textarea
                  {...register("message")}
                  rows={5}
                  placeholder="Please type your message in detail..."
                  className={`w-full border rounded-xl p-3.5 text-xs text-slate-900 bg-slate-50/50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[var(--brand-accent)] transition-all ${
                    errors.message ? "border-rose-400" : "border-slate-200"
                  }`}
                />
                {errors.message && (
                  <p className="text-xs text-rose-500 font-medium">{errors.message.message}</p>
                )}
              </div>

              {/* ReCAPTCHA */}
              <div className="pt-2">
                <ReCAPTCHA
                  sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || "6LccJiosAAAAAGF_7a3p32-tiPQcyeZ0aBWu-PYM"}
                  onChange={handleCaptchaChange}
                  ref={recaptchaRef}
                />
              </div>


              {/* Submit Button */}
              <Button
                type="submit"
                disabled={loading}
                className="w-full h-12 bg-black hover:bg-slate-800 text-white font-bold text-xs uppercase tracking-wider rounded-xl cursor-pointer shadow-md transition-all flex items-center justify-center gap-2"
              >
                {loading ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    <span>Sending Message...</span>
                  </>
                ) : (
                  <>
                    <span>Send Message</span>
                    <Send className="w-4 h-4" />
                  </>
                )}
              </Button>
            </form>
          </div>

          {/* Right Column: FAQ & Help Info */}
          <div className="lg:col-span-5 space-y-6">
            <div className="bg-white rounded-2xl border border-slate-200/90 p-6 shadow-xs space-y-4">
              <div className="flex items-center gap-2.5 text-slate-900 font-bold text-base border-b border-slate-100 pb-3">
                <HelpCircle className="w-5 h-5 text-[var(--brand-accent)]" />
                <span>Need Instant Answers?</span>
              </div>
              <p className="text-xs text-slate-600 leading-relaxed">
                Before reaching out, check our international shipping guidelines and promotional deals for quick solutions:
              </p>
              <div className="space-y-2.5 pt-1">
                <button
                  type="button"
                  onClick={() => fastPush("/shipping-policy")}
                  className="w-full p-3 rounded-xl border border-slate-200 hover:border-[var(--brand-accent)] bg-slate-50/50 hover:bg-amber-50/40 text-left transition-all flex items-center justify-between group cursor-pointer"
                >
                  <div className="flex items-center gap-2.5">
                    <CheckCircle2 className="w-4 h-4 text-emerald-600" />
                    <span className="text-xs font-semibold text-slate-800 group-hover:text-[var(--brand-accent)]">
                      Shipping & Delivery Timelines
                    </span>
                  </div>
                  <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-[var(--brand-accent)]" />
                </button>

                <button
                  type="button"
                  onClick={() => fastPush("/crazy-deals")}
                  className="w-full p-3 rounded-xl border border-slate-200 hover:border-[var(--brand-accent)] bg-slate-50/50 hover:bg-amber-50/40 text-left transition-all flex items-center justify-between group cursor-pointer"
                >
                  <div className="flex items-center gap-2.5">
                    <Sparkles className="w-4 h-4 text-amber-500" />
                    <span className="text-xs font-semibold text-slate-800 group-hover:text-[var(--brand-accent)]">
                      Deals & Special Offers
                    </span>
                  </div>
                  <ExternalLink className="w-3.5 h-3.5 text-slate-400 group-hover:text-[var(--brand-accent)]" />
                </button>
              </div>
            </div>

            {/* Map Preview Card */}
            <div className="bg-white rounded-2xl border border-slate-200/90 overflow-hidden shadow-xs">
              <div className="p-4 bg-slate-50 border-b border-slate-100 flex items-center justify-between">
                <span className="text-xs font-bold text-slate-800 flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-[var(--brand-accent)]" />
                  <span>Store Location</span>
                </span>
              </div>
              <div className="h-64 w-full bg-slate-100">
                {fullAddress ? (
                  <iframe
                    src={`https://www.google.com/maps?q=${encodeURIComponent(fullAddress)}&output=embed`}
                    width="100%"
                    height="100%"
                    allowFullScreen
                    loading="lazy"
                    className="border-0 w-full h-full"
                  ></iframe>
                ) : (
                  <div className="h-full flex items-center justify-center text-xs text-slate-400">
                    Loading map location...
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Success Dialog Modal */}
      <Modal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
        <div className="p-6 sm:p-8 text-center space-y-4">
          <div className="w-16 h-16 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto mb-2 shadow-xs">
            <CheckCircle2 className="w-10 h-10 text-emerald-600" />
          </div>
          <h3 className="text-xl font-bold text-slate-900">Message Received!</h3>
          <p className="text-xs sm:text-sm text-slate-600 max-w-md mx-auto leading-relaxed">
            Thank you for contacting us. We have successfully received your inquiry and our support team will review your message and solve or get back to you soon.
          </p>
          <div className="pt-3">
            <Button
              type="button"
              onClick={() => setShowSuccessModal(false)}
              className="bg-black hover:bg-slate-800 text-white font-bold px-6 py-2.5 rounded-xl text-xs uppercase tracking-wider shadow-xs cursor-pointer"
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </main>
  );
}
